module.exports = __webpack_public_path__ + "img/search-icon.0aa33da1.svg";